import { render } from "./NewAgenda.vue?vue&type=template&id=317ce4a6&scoped=true"
import script from "./NewAgenda.vue?vue&type=script&lang=js"
export * from "./NewAgenda.vue?vue&type=script&lang=js"

import "./NewAgenda.vue?vue&type=style&index=0&id=317ce4a6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-317ce4a6"]])

export default __exports__